module.exports = __webpack_public_path__ + "assets/images/project/laos.jpg?v=beb1c550";